import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/work/english/new-evaluation/src/admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var dispatch, _ref2, _ref2$username, username, _ref2$password, password, token;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = _ref.dispatch;
                _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$username = _ref2.username, username = _ref2$username === void 0 ? '' : _ref2$username, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password;
                _context.next = 4;
                return api.userLogin({
                  username: username,
                  password: password
                });

              case 4:
                token = _context.sent;
                util.cookies.set('uuid', username);
                util.cookies.set('token', token);
                _context.next = 9;
                return dispatch('d2admin/user/set', {
                  name: username
                }, {
                  root: true
                });

              case 9:
                _context.next = 11;
                return dispatch('load');

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$confirm = _ref4.confirm,
          confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove('token');
                  util.cookies.remove('uuid'); // 清空 vuex 用户信息

                  _context2.next = 4;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 4:
                  // 跳转路由
                  router.push({
                    name: 'login'
                  });

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dispatch = _ref5.dispatch;
                _context3.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                _context3.next = 5;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 5:
                _context3.next = 7;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 7:
                _context3.next = 9;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 9:
                _context3.next = 11;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 11:
                _context3.next = 13;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 13:
                _context3.next = 15;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};